<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <card class="striped-tabled-with-hover p-0 m-0"
                body-classes="table-full-width table-responsive p-0 m-0">
            <template slot="header">
              <h4 class="card-title">Piek weken</h4>
              <p class="card-category">De piekweken waar je meer verkopen verwacht (weeknummers)</p>
            </template>

            <div class="alert alert-success m-3" v-if="updated">Settings zijn aangepast</div>

            <div class="px-3"  v-if="settings['y2019_ramadan']">
              <h4>2019</h4>
              <div class="row">
                <div class="col">
                  <label>Ramadan</label>
                  <input class="form-control" type="text" v-model="settings['y2019_ramadan'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Fitr</label>
                  <input class="form-control" type="text" v-model="settings['y2019_eid_fitr'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Adha</label>
                  <input class="form-control" type="text" v-model="settings['y2019_eid_adha'].value"/>
                </div>
                <div class="col">
                  <label>December</label>
                  <input class="form-control" type="text" v-model="settings['y2019_december'].value"/>
                </div>
                <div class="col">
                  <label>Overig</label>
                  <input class="form-control" type="text" v-model="settings['y2019_other'].value"/>
                </div>
              </div>

              <h4>2020</h4>
              <div class="row">
                <div class="col">
                  <label>Ramadan</label>
                  <input class="form-control" type="text" v-model="settings['y2020_ramadan'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Fitr</label>
                  <input class="form-control" type="text" v-model="settings['y2020_eid_fitr'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Adha</label>
                  <input class="form-control" type="text" v-model="settings['y2020_eid_adha'].value"/>
                </div>
                <div class="col">
                  <label>December</label>
                  <input class="form-control" type="text" v-model="settings['y2020_december'].value"/>
                </div>
                <div class="col">
                  <label>Overig</label>
                  <input class="form-control" type="text" v-model="settings['y2020_other'].value"/>
                </div>
              </div>

              <h4>2021</h4>
              <div class="row">
                <div class="col">
                  <label>Ramadan</label>
                  <input class="form-control" type="text" v-model="settings['y2021_ramadan'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Fitr</label>
                  <input class="form-control" type="text" v-model="settings['y2021_eid_fitr'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Adha</label>
                  <input class="form-control" type="text" v-model="settings['y2021_eid_adha'].value"/>
                </div>
                <div class="col">
                  <label>December</label>
                  <input class="form-control" type="text" v-model="settings['y2021_december'].value"/>
                </div>
                <div class="col">
                  <label>Overig</label>
                  <input class="form-control" type="text" v-model="settings['y2021_other'].value"/>
                </div>
              </div>

              <h4>2022</h4>
              <div class="row">
                <div class="col">
                  <label>Ramadan</label>
                  <input class="form-control" type="text" v-model="settings['y2022_ramadan'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Fitr</label>
                  <input class="form-control" type="text" v-model="settings['y2022_eid_fitr'].value"/>
                </div>
                <div class="col">
                  <label>Eid ul Adha</label>
                  <input class="form-control" type="text" v-model="settings['y2022_eid_adha'].value"/>
                </div>
                <div class="col">
                  <label>December</label>
                  <input class="form-control" type="text" v-model="settings['y2022_december'].value"/>
                </div>
                <div class="col">
                  <label>Overig</label>
                  <input class="form-control" type="text" v-model="settings['y2022_other'].value"/>
                </div>
              </div>

              <br/>

              <div class="btn btn-warning" @click="update()">Aanpassen</div>

            </div>

          </card>
          <br/>

        </div>
        <div class="col-md-4">
          <card class="striped-tabled-with-hover p-0 m-0"
                body-classes="table-full-width table-responsive p-0 m-0">
            <template slot="header">
              <h4 class="card-title">Engine instellingen</h4>
              <p class="card-category">Instellingen voor de engine om tot betere resultaten te komen.</p>
            </template>

            <div class="alert alert-success m-3" v-if="updated">Settings zijn aangepast</div>

            <form class="form-inline p-3 text-muted">
              <p>R1: De engine kan <b>geen</b> advies geven <i class="fa fa-circle text-danger"></i> bij nieuwe producten <b>jonger</b> dan:
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r1'].value"/> weken.</p>
              <p>R2: De engine kan <b>geen</b> advies geven <i class="fa fa-circle text-danger"></i> bij producten die <b>niet verkocht</b> zijn voor meer dan:
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r2'].value"/> weken.</p>
              <p>R3: De engine moet bij een dal periode voor een minimale voorraad zorgen voor:
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r3'].value"/> weken.</p>
              <p>R4: De engine moet naast de minimale voorraad, rekening houden met een extra voorraad hebben van:
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r4'].value"/> %.</p>
              <p>R5: De engine kan geen goed advies geven (en geeft een waarschuwing: <i class="fa fa-circle text-warning"></i>) bij piekweken als de data van de jaren ervoor ontbreekt.
                De engine zal dan een advies uitgeven op basis van een dalweek.
              </p>
              <p>R6: De engine begint met de voorbereiding / aanschaf <i class="fa fa-circle text-info"></i> van extra producten voor de piekweken met
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r6'].value"/> weken.
              </p>
              <p>R7: De engine houdt rekening met de voorraad van producten tot:
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r7'].value"/> weken terug.
              </p>
              <p>R8: De engine houdt rekening met nieuwe producten die gehyped worden, dus negeert de eerste
                <input type="text" class="form-control-sm" style="max-width: 40px" v-model="settings['r8'].value"/> weken.
              </p>

              <div class="btn btn-warning" @click="update()">Aanpassen</div>

            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";

  export default {
    components: {
    },
    data () {
      return {
        updated: false,
        settings: {
          y2019_ramadan: {},
          y2019_eid_fitr: {},
          y2019_eid_adha: {},
          y2019_december: {},
          y2019_other: {},
          y2020_ramadan: {},
          y2020_eid_fitr: {},
          y2020_eid_adha: {},
          y2020_december: {},
          y2020_other: {},
          y2021_ramadan: {},
          y2021_eid_fitr: {},
          y2021_eid_adha: {},
          y2021_december: {},
          y2021_other: {},
          y2022_ramadan: {},
          y2022_eid_fitr: {},
          y2022_eid_adha: {},
          y2022_december: {},
          y2022_other: {}
        }
      }
    },

    methods: {
      getSettings() {
        var self = this
        axios.get("/api/settings")
          .then((response) => {
            response.data.forEach((s) => {
              if (!s.value) {
                s.value = ''
              }
              self.settings[s.topic] = s;
            });
            self.isLoading = false
          })
          .catch((errors) => {
            console.log("Cannot get settings")
            console.log(errors)
          })
      },
      update() {
        let settings = Object.values(this.settings)
        let self = this
        axios.post("/api/settings", settings)
          .then(() => {
            self.updated = true
          })
          .catch((errors) => {
            console.log("Cannot update settings")
            console.log(errors)
          })
      }
    },
    mounted() {
      this.getSettings()
    }
  }

</script>
<style>

</style>
